import { useEffect, useState } from 'react';
import { useSearchParams } from 'react-router-dom';

/**
 * Vuelta de Stripe con `?ok=1`. Se lee una sola vez y se quita de la URL: recargar la página no
 * debe volver a anunciar un pago que ya se anunció.
 */
export function usePaymentReturn(): boolean {
  const [searchParams, setSearchParams] = useSearchParams();
  const [justPaid] = useState(() => searchParams.get('ok') === '1');

  useEffect(() => {
    if (searchParams.has('ok')) {
      setSearchParams(
        (params) => {
          params.delete('ok');
          return params;
        },
        { replace: true },
      );
    }
  }, [searchParams, setSearchParams]);

  return justPaid;
}
